import { Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import UserProfileToggle from './user_profile_toggle';

function initialSpecialtiesSelected(specialtiesOptions, userSpecialties) {
  const selectedBrokerSpecialtyId = userSpecialties.map(s => s.brokerSpecialtyId);
  return specialtiesOptions.filter(o => selectedBrokerSpecialtyId.includes(o.value));
}

export default function Specialties({
  allBrokerSpecialties,
  pcUser = false,
  showSpecialtiesOnBrokerPlugin,
  userSpecialties
}) {
  const specialtiesOptions = allBrokerSpecialties.map(a => ({ value: a.id, label: a.title }));
  const [selectedSpecialties, setSelectedSpecialties] = useState(
    () => initialSpecialtiesSelected(specialtiesOptions, userSpecialties)
  );
  const [specialtiesOnBrokerPlugin, setSpecialtiesOnBrokerPlugin] = useState(showSpecialtiesOnBrokerPlugin);

  const selectedSpecialtyIds = selectedSpecialties.map(s => s.value);
  const persistedBrokerSpecialties = userSpecialties.map(s => s.brokerSpecialtyId);
  const newSpecialtyIds = selectedSpecialtyIds.filter(id => !persistedBrokerSpecialties.includes(id));

  const pcUserPrefix = pcUser ? 'parent_company_' : '';
  const specialtyBaseName = `${pcUserPrefix}user[${pcUserPrefix}user_broker_specialties_attributes]`;

  return (
    <React.Fragment>
      <h2 className="top-buffer-lg">Specialties</h2>

      <Row className="form-group">
        <Col md={6}>
          <Select
            classNamePrefix="react-select-buildout"
            isMulti
            options={specialtiesOptions}
            value={selectedSpecialties}
            onChange={setSelectedSpecialties}
          />
        </Col>
      </Row>

      {userSpecialties.map((userSpecialty, index) => {
        const isSelected = selectedSpecialtyIds.includes(userSpecialty.brokerSpecialtyId);

        return (
          <React.Fragment key={userSpecialty.id}>
            <input name={`${specialtyBaseName}[${index}][id]`} type="hidden" value={userSpecialty.id}/>
            <input
              name={`${specialtyBaseName}[${index}][broker_specialty_id]`}
              type="hidden"
              value={userSpecialty.brokerSpecialtyId}
            />
            <input
              name={`${specialtyBaseName}[${index}][_destroy]`}
              type="hidden"
              value={!isSelected}
            />
          </React.Fragment>
        );
      })}

      {newSpecialtyIds.map((specialtyId, i) => {
        const index = i + userSpecialties.length;

        return (
          <React.Fragment key={specialtyId}>
            <input
              name={`${specialtyBaseName}[${index}][broker_specialty_id]`}
              type="hidden"
              value={specialtyId}
            />
          </React.Fragment>
        );
      })}

      {!pcUser &&
        <UserProfileToggle
          checked={specialtiesOnBrokerPlugin}
          label="Show on Broker Plugin"
          name="user[show_specialties_on_broker_plugin]"
          onChange={() => setSpecialtiesOnBrokerPlugin(!specialtiesOnBrokerPlugin)}
        />
      }
    </React.Fragment>
  );
}

// PropTypes exports
export const userSpecialtiesPropType = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.number,
  brokerSpecialtyId: PropTypes.number,
})).isRequired;

export const specialtiesPropTypes = {
  allBrokerSpecialties: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
  })).isRequired,
  showSpecialtiesOnBrokerPlugin: PropTypes.bool.isRequired,
  userSpecialties: userSpecialtiesPropType
};

Specialties.propTypes = {
  ...specialtiesPropTypes,
  pcUser: PropTypes.bool
};
